import { PRODUCT_TYPES } from '@/lib';

/**
 * Linksite page types that a V2 funnel page is allowed to reference. Drives
 * the product selector dropdown in the funnel editor. Mirrors Vue
 * PageFunnel.vue `applicableProductTypes`.
 */
export const FUNNEL_APPLICABLE_PRODUCT_TYPES: ReadonlySet<string> = new Set([
    PRODUCT_TYPES.DIGITAL_DOWNLOAD,
    PRODUCT_TYPES.COURSE,
    PRODUCT_TYPES.COMMUNITY,
    PRODUCT_TYPES.LEAD_MAGNET,
    PRODUCT_TYPES.BOOKING,
    PRODUCT_TYPES.FULFILLMENT,
    PRODUCT_TYPES.MEMBERSHIP,
    PRODUCT_TYPES.WEBINAR,
]);

/**
 * Slug validation regex — only letters, numbers, underscores
 */
export const FUNNEL_SLUG_REGEX = /^[A-Za-z0-9_]*$/;

/**
 * Default top banner text for non-first funnel pages
 */
export const DEFAULT_TOP_BANNER_TEXT =
    "<h3>WAIT!</h3><p>Your Order Is Not Yet Complete!<br />Here's a ONE TIME DISCOUNT!</p>";

export const DRAFT_FUNNEL_PAGE_ID = -1;

export const MAX_FUNNEL_PAGES = 20;

export const MAX_BRANCH_DEPTH = 5;

/**
 * Funnel page statuses (matches backend `Status` enum in stan_app/utils/__init__.py).
 */
export const FUNNEL_PAGE_STATUS = {
    DELETED: 0,
    DRAFT: 1,
    PUBLISHED: 2,
} as const;

/**
 * Funnel store statuses (matches backend `Status` enum in stan_app/utils/__init__.py).
 */
export const FUNNEL_STATUS = {
    DELETED: 0,
    DRAFT: 1,
    PUBLISHED: 2,
} as const;
